import { optionTypes } from 'ui/common/select/constants';
import { ComplexValue, MeatballPanelConfiguration } from '../types';

export interface Translations {
  textOptionsNotFound?: string;
  textOptionsDone?: string;
  textOptionsLoadError?: string;
  textSearchRequired?: string;
  textSearchRequiredExceedsMaxResult?: string;
  textSelectAll?: string;
  textClearAll?: string;
  textPageOf?: string;
}

export interface SelectCommonProps extends Translations {
  /**
   * @private Define whether options list is open.
   * Allows overriding the component state from the outside.
   */
  isOpen?: boolean;
  /**
   * It overrides optionsDisplaySetting props and makes that options list is always flat list.
   */
  hideAlphabeticIndex?: boolean;
  /**
   * TODO: determine if this should be controlled by onLoadOptions parameter instead
   * 
   * [[OptionsDisplaySetting]] Define how options list is displayed.
   *
   * Depend on optionsParam.type, we have possibility:
   * - simple: displays a simple list.
   * - index: displays a list with index tiles.
   * - auto: displays a list simple or index  which are depend on indexMin and indexMax params.
   */
  optionsDisplaySetting?: OptionsDisplaySetting;
  /**
   * Set options list on always open.
   *
   * Example
   * - You can use for mobile view where component will be on a whole view.
   */
  alwaysOpen?: boolean;
  /**
   * @private Set min length of input text to call search. Default is '2'.
   * 
   */
  minLength?: number;
  disabled?: boolean;
  showIcons?: boolean;

  /**
   * If set to true, shows backgroundColor of ComplexValue as circle filled with given color.
   * backgroundColor is expected to be a hex number. 
   */
  showBackgroundColour?: boolean;
  /**
   * It allow user to change internal state to show long description inside options.
   * If all of options doesn't have long description then long description won't show. 
   * Default is true.
   */
  longDescription?: boolean;
  /**
   * It determines whether long description switch is enabled.
   * Default is true.
   */
  initiallyShowLongDescription?: boolean;
  
  searchRequired?: boolean;  
  categoryId?: number;
  extraFooterButton?: ExtraFooterButton;
  enableMultilineValidation?: boolean;
  displayCategories?: boolean;
  showIndexWhenNoOfPagesIsAbove?: number;
  meatballPanelConfiguration?: MeatballPanelConfiguration;
  includeDisabledLabel?: string;
  uncheckSelectItem?: boolean;
}

export interface GroupData {
  name: string;
  items: SelectItem[];
  bookmarkId: string;
}

export type ValueItem = ComplexValue<number | string>;

export interface SelectItem extends ValueItem {
  isSelected?: boolean;
  readOnly?: boolean;
  active?: boolean;
  title?: string;
  type?: optionTypes;
  category?: ComplexValue<number>;
}

export enum SelectType {
  single = 1,
  multiple = 2,
  singleHierarchy = 3,
  multipleHierarchy = 4
}

export enum OptionsType {
  flat = 0,
  index = 1,
  auto = 2,
  hierarchy = 3
}

export interface OptionsDisplaySetting {
  type?: OptionsType;
  indexMin?: number;
}

export type ExtraFooterButton = (onClose: () => void) => JSX.Element;
